<template>
  <div id="add-user">
    <v-btn block class="button-add-user" @click="dialog = true">
      <v-icon left>mdi-plus-circle-outline</v-icon>
      เพิ่มผู้ใช้งาน
    </v-btn>
    <v-dialog v-model="dialog" max-width="500">
      <v-card>
        <v-card-title class="tw-mt-4">
          <div class="tw-font-bold tw-text-xl">เพิ่มผู้ใช้งานใหม่</div>
          <v-spacer></v-spacer>
          <!-- Disabled mid-send: closing would drop the register code before
               the admin has had a chance to copy it. -->
          <v-btn icon title="ปิด" :disabled="registerAndSendEmailLoading" @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="tw-pb-0">
          <v-row>
            <v-col>
              <v-text-field v-model="email" label="กรุณากรอกอีเมล" single-line outlined
                            class="input-style" :disabled="registerAndSendEmailLoading"></v-text-field>
<!--              <v-text-field v-model="email" label="กรุณากรอกอีเมล" @input="search" single-line outlined-->
<!--                            class="input-style" :disabled="registerAndSendEmailLoading"></v-text-field>-->
            </v-col>
          </v-row>
<!--          <div v-if="userSearch">-->
<!--            <p>{{ userSearch.nameFirstTH }} {{ userSearch.nameLastTH }}</p>-->
<!--          </div>-->
          <v-radio-group v-model="role" row :disabled="registerAndSendEmailLoading" class="tw-mt-0">
            <v-radio v-if="userAuth?.isEngineer"  label="SLD Admin" color="#6ec39b" value="developer"></v-radio>
            <v-radio :label="product?.isPdfDoc ? 'IT Admin' : 'Owner'" color="#6ec39b" value="owner"></v-radio>
            <v-radio label="User" color="#6ec39b" value="user"></v-radio>
          </v-radio-group>
        </v-card-text>
        <save-alert :status="emailStatus && (emailStatus === 'success' ? 'success': 'error')"
                    :error-text="alertText[emailStatus]"
                    success-text="ส่งอีเมลลงทะเบียนสำเร็จ" v-if="emailStatus"></save-alert>
        <!-- The code is shown even when the mail went out fine: customers on
             Microsoft 365 regularly find the invite sitting in quarantine, and
             the admin can just read the code out instead of re-inviting. -->
        <div v-if="registerToken" class="register-code">
          <div class="register-code__head">
            <v-icon small color="#6ec39b">mdi-key-variant</v-icon>
            <span class="register-code__title">โค้ดลงทะเบียน</span>
          </div>
          <p class="register-code__hint">
            ส่งให้ผู้ใช้งานโดยตรงได้ หากอีเมลไปไม่ถึง
          </p>
          <!-- user-select:all so one click selects the whole code for someone
               who would rather drag-copy than use the button. -->
          <div class="register-code__value"
               :class="{ 'is-copied': tokenCopied }"
               title="คลิกเพื่อคัดลอก"
               @click="copyToken">{{ registerToken }}</div>
          <v-btn depressed block class="register-code__button" @click="copyToken">
            <v-icon small left>{{ tokenCopied ? 'mdi-check' : 'mdi-content-copy' }}</v-icon>
            {{ tokenCopied ? 'คัดลอกแล้ว' : 'คัดลอกโค้ด' }}
          </v-btn>
        </div>
        <v-card-actions class="tw-mb-2">
          <v-spacer></v-spacer>
<!--          <v-btn color="#6ec39b" text @click="addUser" v-if="userSearch" :disabled="registerAndSendEmailLoading">-->
<!--            <v-icon left>mdi-plus-circle-outline</v-icon>-->
<!--            เพิ่มผู้ใช้งาน-->
<!--          </v-btn>-->
<!--          <v-btn color="#6ec39b" text @click="sendEmailInvite" v-else-if="email && !userSearch" :disabled="registerAndSendEmailLoading">-->
          <v-btn color="#6ec39b" text @click="sendEmailInvite" :disabled="registerAndSendEmailLoading" class="tw-tracking-normal tw-text-lg tw-mr-2">
            <v-progress-circular
              indeterminate
              color="green"
              style="margin-right: 10px;"
              v-if="registerAndSendEmailLoading"
            ></v-progress-circular>
            <img
              src="/images/icons/icon_send_email.svg"
              class="tw-mr-2 tw-w-6"
              v-else
            />
            ส่งอีเมล
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {mapState} from "vuex";
import firebase from "firebase/app";
import "firebase/auth"
import fc from "@/firebaseConfig";
import SaveAlert from '../save-alert'

const axios = require("axios");

export default {
  name: 'AddUser',
  components:{
    SaveAlert
  },
  props:{
    product: Object,
  },
  data() {
    return {
      email: null,
      dialog: false,
      role: 'owner',
      registerAndSendEmailLoading: false,
      emailStatus: null,
      registerToken: null,
      tokenCopied: false,
      alertText:{
        error: "เพิ่มผู้ใช้ไม่สำเร็จ กรุณาลองใหม่อีกครั้ง",
        sendError: "ส่งอีเมลไม่สำเร็จ แต่โค้ดถูกสร้างแล้ว ให้คัดลอกโค้ดด้านล่างส่งให้ผู้ใช้งานเอง",
        permission: "คุณไม่มีสิทธิ์เพิ่มผู้ใช้งานในบริษัทนี้ กรุณาให้ Owner ของบริษัทนี้เป็นผู้เพิ่ม",
        auth: "เซสชันหมดอายุ กรุณาออกจากระบบแล้วเข้าสู่ระบบใหม่อีกครั้ง",
        company: "ไม่พบข้อมูลบริษัท กรุณารีเฟรชหน้าเว็บแล้วลองใหม่อีกครั้ง",
      }
    }
  },
  computed: mapState({
    userSearch: state => state.user.userSearch,
    userAuth: state => state.user.userData,
  }),
  methods: {
    // search: function () {
    //   if (this.email) {
    //     this.$store.dispatch('user/search', {email: this.email})
    //   }
    // },
    // addUser: function () {
    //   this.dialog = false
    //   let companyId = this.$route.params.companyId
    //   this.$store.dispatch('user/addUserInCompany', {companyId: companyId, user: this.userSearch, role: this.role}).then(() => {
    //     this.email = ""
    //     this.$store.dispatch('user/setSearchEmpty')
    //   })
    // },
    copyToken: function () {
      if (!this.registerToken) return
      const done = () => {
        this.tokenCopied = true
        setTimeout(() => { this.tokenCopied = false }, 2000)
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(this.registerToken).then(done, () => {})
        return
      }
      // Older browsers on the customer side still land here.
      const el = document.createElement('textarea')
      el.value = this.registerToken
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
      done()
    },
    sendEmailInvite: async function () {
      this.registerAndSendEmailLoading = true
      this.emailStatus = null
      this.registerToken = null
      this.tokenCopied = false
      // get user token
      let token = await firebase.auth().currentUser.getIdToken(/* forceRefresh */ false)
        .then(function (idToken) {
          return idToken
        });
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': 'JWT ' + token
      }

      let data = {
        companyID: this.$route.params.companyId,
        email: this.email,
        role: this.role
      }

      await axios.post(fc.getFunctionUrl("registerUserAndSendEmail"), data, {headers})
        .then((response) => {
          if (response.status === 200) {
            this.emailStatus = 'success'
            this.registerToken = response.data && response.data.token ? response.data.token : null
            this.email = ""
            // Tell the settings page to refresh "invited, not joined yet".
            this.$emit('invited')
          }
        }, (error) => {
          const status = error.response ? error.response.status : null
          const body = error.response ? error.response.data : null
          const reason = body && typeof body === 'object' ? body.error : body

          if (body && typeof body === 'object' && body.token) {
            this.registerToken = body.token
            this.$emit('invited')
          }

          // Match on the reason the function sent back first - the status
          // alone cannot tell 'Company Missing' from 'Generate Token Error',
          // both of which come back as 400.
          if (reason === 'Not Company Admin' || status === 403) {
            this.emailStatus = 'permission'
          } else if (reason === 'User Auth Error' || status === 401) {
            this.emailStatus = 'auth'
          } else if (reason === 'Company Missing') {
            this.emailStatus = 'company'
          } else if (reason === 'Mail Server Error') {
            this.emailStatus = 'sendError'
          } else {
            this.emailStatus = 'error'
          }
        });
      this.registerAndSendEmailLoading = false
    }
  },
  watch:{
    dialog:{
      handler: function (){
        if(!this.dialog){
          this.emailStatus = null
          this.email = null
          this.registerToken = null
          this.tokenCopied = false
          this.role = 'owner'        }
      }
    }
  }
}
</script>

<style lang="scss">
#add-user {
  .v-application .headline {
    font-family: "Noto Sans Thai", "Noto Sans", sans-serif !important;
  }

  .input-style.v-input .v-input__slot {
    border-radius: 10px;
  }

  .v-text-field__details {
    display: none !important;
  }

  .button-add-user {
    background-color: white !important;
    border-top: thin solid #6ec39b;
    border-bottom: thin solid #6ec39b;
    box-shadow: unset !important;
    border-radius: unset;
  }

  .alert-detail {
    padding-left: 20px;
    padding-right: 20px;
  }
}

/* Deliberately NOT nested under #add-user: v-dialog is detachable, so its
   content is moved to the app root at open time and a selector scoped to this
   component's tree never matches it. */
.register-code {
  margin: 8px 20px 0;
  padding: 16px 18px;
  border: 1px solid #d8ede2;
  border-radius: 12px;
  background-color: #f6fbf8;

  &__head {
    display: flex;
    align-items: center;
  }

  &__title {
    margin-left: 6px;
    font-size: 15px;
    font-weight: bold;
    color: #2f6b4f;
  }

  &__hint {
    margin: 4px 0 12px;
    font-size: 12px;
    line-height: 1.5;
    color: #7a8b82;
  }

  &__value {
    padding: 12px 14px;
    border: 1px dashed #b9dccb;
    border-radius: 8px;
    background-color: #ffffff;
    color: #2c3e37;
    font-family: "Roboto Mono", "Courier New", monospace;
    font-size: 13px;
    line-height: 1.9;
    letter-spacing: 0.6px;
    word-break: break-all;
    cursor: pointer;
    user-select: all;
    transition: border-color 0.2s ease, background-color 0.2s ease;

    &:hover {
      border-color: #6ec39b;
    }

    &.is-copied {
      border-style: solid;
      border-color: #6ec39b;
      background-color: #f0faf5;
    }
  }

  &__button {
    margin-top: 12px;
    border-radius: 8px;
    background-color: #6ec39b !important;
    color: #ffffff !important;
    letter-spacing: normal;
    font-size: 15px;
  }
}
</style>
